<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <!-- 列表 -->
      <div class="bannerList" v-show="pageShow == 'index'">
        <!-- 顶部起始位置 -->
        <div class="topBox flex">
          <ul class="flex">
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchName" placeholder="请输入规则名称"></el-input>
              </div>
            </li>
            <li class="flex" style="margin-left:15px">
              <div style="width: 240px">
                <el-input v-model="searchDescription" placeholder="请输入规则描述"></el-input>
              </div>
            </li>
            <li class="flex" style="margin-left:15px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>
        </div>
        <!-- 顶部结束位置 -->

        <template>
          <el-table border :data="tableData" style="width: 100%">
            <!-- <el-table-column prop="id" align="center" label="ID" width="80">
            </el-table-column> -->
            <el-table-column prop="code" align="center" label="规则编码">
            </el-table-column>
            <el-table-column prop="name" align="center" label="规则名称">
            </el-table-column>
            <el-table-column prop="description" align="center" label="规则描述" min-width="200">
            </el-table-column>
            <!-- <el-table-column prop="createTime" align="center" label="创建时间" width="180">
            </el-table-column> -->
            <el-table-column align="center" label="操作" width="350">
              <template slot-scope="scope">
                <el-button type="info" size="small" @click="viewBrandsFn(scope.$index)">查看关联品牌</el-button>
                <el-button type="primary" size="small" @click="linkBrandFn(scope.$index)">关联品牌</el-button>
                <el-button type="success" size="small" @click="editFn(scope.$index)">编辑</el-button>
                <!-- <el-button type="danger" size="small" @click="delFn(scope.$index)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="page_box">
          <el-pagination @current-change="changePage" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next,jumper" :total="tableTotal">
          </el-pagination>
        </div>
      </div>

      <!-- 关联品牌弹窗 -->
      <div class="excellent_box" v-if="linkBrandShow">
        <div class="excellent_main">
          <div class="excellent_top">
            关联品牌
            <i class="el-icon-close" @click.stop="closeLinkBrandFn"></i>
          </div>

          <div class="excellent_content">
            <div class="excellent_li flex">
              <span>选择品牌：</span>
              <div style="width: 290px">
                <el-select
                  v-model="selectedBrandId"
                  filterable
                  placeholder="请选择品牌"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in brandData"
                    :value="item.id"
                    :key="index"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="excellent_btn flex">
              <el-button type="success" size="small" @click.stop="confirmLinkBrandFn">提交</el-button>
              <el-button type="info" size="small" @click.stop="closeLinkBrandFn">取消</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 编辑弹窗 -->
      <div class="excellent_box" v-if="editShow">
        <div class="excellent_main" style="height: 300px;">
          <div class="excellent_top">
            编辑规则
            <i class="el-icon-close" @click.stop="closeEditFn"></i>
          </div>

          <div class="excellent_content">
            <div class="excellent_li flex">
              <span>规则名称：</span>
              <div style="width: 290px">
                <el-input
                  v-model="editForm.name"
                  placeholder="请输入规则名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>规则描述：</span>
              <div style="width: 290px">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="editForm.description"
                  placeholder="请输入规则描述"
                ></el-input>
              </div>
            </div>

            <div class="excellent_btn flex">
              <el-button type="success" size="small" @click.stop="confirmEditFn">提交</el-button>
              <el-button type="info" size="small" @click.stop="closeEditFn">取消</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 查看关联品牌弹窗 -->
      <div class="excellent_box" v-if="viewBrandsShow">
        <div class="excellent_main" style="height: 400px; width: 600px;">
          <div class="excellent_top">
            关联品牌列表
            <i class="el-icon-close" @click.stop="closeViewBrandsFn"></i>
          </div>

          <div class="excellent_content" style="max-height: 320px; overflow-y: auto;">
            <el-table border :data="linkedBrandsList" style="width: 100%" v-if="linkedBrandsList.length > 0">
              <!-- <el-table-column prop="id" align="center" label="ID" width="80">
              </el-table-column> -->
              <el-table-column prop="name" align="center" label="品牌名称">
              </el-table-column>
              <el-table-column prop="englishName" align="center" label="英文名称">
              </el-table-column>
              <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delLinkedBrandFn(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else style="text-align: center; padding: 20px; color: #999;">
              暂无关联品牌
            </div>
          </div>

          <!-- <div class="excellent_btn flex">
            <el-button type="info" size="small" @click.stop="closeViewBrandsFn">关闭</el-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { delTips, throttle, returnTime } from "@/util/utils";
export default {
  data() {
    return {
      // 历史记录
      historyArr: ["批号查询管理", "品牌逻辑"],

      // 搜索
      searchName: "",
      searchDescription: "",

      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      pageShow: "index",
      tableData: [],
      
      // 关联品牌相关
      linkBrandShow: false,
      selectedBrandId: "",
      brandData: [],
      currentRuleId: null, // 当前操作的规则ID
      currentRuleCode: "", // 当前操作的规则编码
      
      // 编辑相关
      editShow: false,
      editForm: {
        id: null,
        name: "",
        description: ""
      },
      
      // 查看关联品牌相关
      viewBrandsShow: false,
      linkedBrandsList: [],
      currentViewCode: "" // 当前查看的逻辑编码
    };
  },
  created() { },
  mounted() {
    this.selListFn(1); //查询
    this.selBrandFn(); // 获取品牌列表
  },
  methods: {
    // 分页
    changePage: function (page) {
      this.selListFn(page)
    },

    // 搜索
    searchFn: function (res) {
      this.selListFn(1)
    },

    // 查询
    selListFn: function (page) {
      if (page) {
        this.currentPage = page;
      }
      var obj = {
        page: this.currentPage || 1,
        size: this.pageSize
      };

      if (this.searchName) {
        obj.name = this.searchName;
      }
      if (this.searchDescription) {
        obj.description = this.searchDescription;
      }

      this.$https(this.$api.api.selBatchCalLogic, obj, "GET").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data || [];
          // 格式化时间
          data.forEach((v) => {
            if (v.createTime) {
              v.createTime = returnTime(new Date(v.createTime), "-", "s");
            }
          });
          this.tableData = data;
          this.tableTotal = res.data.size || 0;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];
      // TODO: 替换为实际的API接口
      // this.$https(
      //   this.$api.api.delBrandLogic,
      //   {
      //     id: list.id,
      //   },
      //   "GET"
      // ).then((res) => {
      //   if (res.data.code == 200) {
      //     this.$message.success("操作成功");
      //     this.selListFn(this.currentPage)
      //   } else {
      //     this.$message.error("操作失败");
      //   }
      // });
    }),

    // 编辑
    editFn: function (index) {
      var list = this.tableData[index];
      this.editForm = {
        id: list.id,
        name: list.name || "",
        description: list.description || ""
      };
      this.editShow = true;
    },

    // 关闭编辑弹窗
    closeEditFn: function () {
      this.editShow = false;
      this.editForm = {
        id: null,
        name: "",
        description: ""
      };
    },

    // 确认编辑
    confirmEditFn: function () {
      if (!this.editForm.name) {
        this.$message.error("请输入规则名称");
        return;
      }

      if (!this.editForm.id) {
        this.$message.error("规则ID不能为空");
        return;
      }

      var obj = {
        id: this.editForm.id,
        name: this.editForm.name,
        description: this.editForm.description || ""
      };

      this.$https(this.$api.api.updateBatchCalLogic, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("更新成功");
          this.closeEditFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error(res.data.msg || "更新失败");
        }
      });
    },

    // 关联品牌
    linkBrandFn: function (index) {
      var list = this.tableData[index];
      this.currentRuleId = list.id;
      this.currentRuleCode = list.code; // 保存规则编码
      this.selectedBrandId = "";
      this.linkBrandShow = true;
    },

    // 关闭关联品牌弹窗
    closeLinkBrandFn: function () {
      this.linkBrandShow = false;
      this.selectedBrandId = "";
      this.currentRuleId = null;
      this.currentRuleCode = "";
    },

    // 确认关联品牌
    confirmLinkBrandFn: function () {
      if (!this.selectedBrandId) {
        this.$message.error("请选择品牌");
        return;
      }

      if (!this.currentRuleCode) {
        this.$message.error("规则编码不能为空");
        return;
      }

      var obj = {
        brandId: this.selectedBrandId,
        batchCalLogicCode: this.currentRuleCode
      };

      this.$https(this.$api.api.saveBrandBatchCalLogic, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("关联成功");
          this.closeLinkBrandFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error(res.data.msg || "关联失败");
        }
      });
    },

    // 查询品牌列表
    selBrandFn: function () {
      var obj = {
        page: 1,
        size: 1000,
      };

      this.$https(this.$api.api.selBrand, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.brandData = res.data.data || [];
        }
      });
    },

    // 查看关联品牌
    viewBrandsFn: function (index) {
      var list = this.tableData[index];
      this.currentViewCode = list.code;
      this.linkedBrandsList = [];
      this.viewBrandsShow = true;
      this.getBrandsByCode(list.code);
    },

    // 关闭查看关联品牌弹窗
    closeViewBrandsFn: function () {
      this.viewBrandsShow = false;
      this.linkedBrandsList = [];
      this.currentViewCode = "";
    },

    // 根据逻辑编码获取关联品牌列表
    getBrandsByCode: function (code) {
      if (!code) {
        this.$message.error("逻辑编码不能为空");
        return;
      }

      var url = this.$api.api.getBrandsByCode + code;
      this.$https(url, {}, "GET").then((res) => {
        if (res.data.code == 200) {
          this.linkedBrandsList = res.data.data || [];
        } else {
          this.linkedBrandsList = [];
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },

    // 删除关联品牌
    delLinkedBrandFn: delTips(function (index) {
      var brand = this.linkedBrandsList[index];
      if (!brand || !brand.id) {
        this.$message.error("品牌信息不完整");
        return;
      }

      // 使用关联关系的 id，如果返回的数据中有关联关系 id，使用关联关系 id
      // 否则使用品牌 id
      var relationId = brand.relationId || brand.id;

      var url = this.$api.api.removeBrandBatchCalLogic + relationId;
      this.$https(url, {}, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          // 重新获取关联品牌列表
          this.getBrandsByCode(this.currentViewCode);
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    }),
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
    justify-content: space-between;
  }

  .bannerList {
    width: 100%;
  }
}

// 关联品牌弹窗
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 450px;
    height: 250px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;
      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;
      padding: 0 15px;
      box-sizing: border-box;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/batchQuery/brandLogic.vue